/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lens-prescription.reducer';

export const LensPrescriptionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const lensPrescriptionEntity = useAppSelector(state => state.lensPrescription.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="lensPrescriptionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.lensPrescription.detail.title">LensPrescription</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.lensPrescription.id">Id</Translate>
            </span>
          </dt>
          <dd>{lensPrescriptionEntity.id}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.lensPrescription.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{lensPrescriptionEntity.timestampentry}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.lensPrescription.active">Active</Translate>
            </span>
          </dt>
          <dd>{lensPrescriptionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.lensPrescription.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{lensPrescriptionEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.lensPrescription.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{lensPrescriptionEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.lensPrescription.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{lensPrescriptionEntity.microSec}</dd>
          <dt>
            <span id="patientType">
              <Translate contentKey="tinyMedicRestApp.lensPrescription.patientType">Patient Type</Translate>
            </span>
          </dt>
          <dd>{lensPrescriptionEntity.patientType}</dd>
          <dt>
            <span id="exposed">
              <Translate contentKey="tinyMedicRestApp.lensPrescription.exposed">Exposed</Translate>
            </span>
          </dt>
          <dd>{lensPrescriptionEntity.exposed ? 'true' : 'false'}</dd>
          <dt>
            <span id="otc">
              <Translate contentKey="tinyMedicRestApp.lensPrescription.otc">Otc</Translate>
            </span>
          </dt>
          <dd>{lensPrescriptionEntity.otc ? 'true' : 'false'}</dd>
          <dt>
            <span id="orderStatus">
              <Translate contentKey="tinyMedicRestApp.lensPrescription.orderStatus">Order Status</Translate>
            </span>
          </dt>
          <dd>{lensPrescriptionEntity.orderStatus}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.lensPrescription.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{lensPrescriptionEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.lensPrescription.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{lensPrescriptionEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.lensPrescription.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{lensPrescriptionEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.lensPrescription.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{lensPrescriptionEntity.modifiedByID}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.lensPrescription.prescription">Prescription</Translate>
          </dt>
          <dd>{lensPrescriptionEntity.prescription ? lensPrescriptionEntity.prescription.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/lens-prescription" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lens-prescription/${lensPrescriptionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LensPrescriptionDetail;
